import { IAddress } from '@/shared/model/address.model';
import { IStall } from '@/shared/model/stall.model';
import { IPferd } from '@/shared/model/pferd.model';
import { ILeistung } from '@/shared/model/leistung.model';
import { ITermin, Termin } from '@/shared/model/termin.model';
import { IKunde } from '@/shared/model/kunde.model';
import { IZusatzleistung, Zusatzleistung } from '@/shared/model/zusatzleistung.model';
import { IGrundleistung } from '@/shared/model/grundleistung.model';
import { FirmaInfo } from '@/shared/model/firm_info.model';
import { IBezahlmgl } from '@/shared/model/bezahlmgl.model';
import axios from 'axios';
import { IAusgabe } from '@/shared/model/ausgabe.model';
import { IMaterial, MaterialXLeistung } from '@/shared/model/material.model';

const baseApiUrl = 'api/v';

export default class ValidationService {
  public checkSammelRechnung(termine: Termin[]): any[] {
    const errors = [];
    const zahlungsarten = [];
    const kunden = [];
    termine.forEach(termin => {
      if (zahlungsarten.indexOf(termin.zahlungsart) === -1) {
        zahlungsarten.push(termin.zahlungsart);
      }
      if (kunden.indexOf(termin.pferd.besitzer.id) === -1) {
        kunden.push(termin.pferd.besitzer.id);
      }
    });
    console.log(kunden);
    console.log(zahlungsarten);
    if (zahlungsarten.length !== 1) {
      errors.push('Bitte nur Termine mit einheitlicher Zahlungsart auswählen.');
    }
    if (kunden.length !== 1) {
      errors.push('Bitte nur Termine mit einheitlichen Kunden auswählen.');
    }
    return errors;
  }

  public checkValidMaterialVerbrauchAdd(materialXLeistung: MaterialXLeistung[]): any[] {
    if (materialXLeistung === null) {
      return ['Bitte Materialverbrauch eingeben.'];
    }
    const errors = [];
    materialXLeistung.forEach(item => {
      if (!item.anzahl) {
        errors.push('Bitte Anzahl ' + item.material.name + ' eingeben');
      }
    });
    return errors;
  }

  public checkValidMaterial(material: IMaterial): any[] {
    if (material === null) {
      return ['Bitte Material eingeben.'];
    }
    const errors = [];
    if (!material.name) {
      errors.push('Bitte Namen eingeben.');
    }
    if (material.einheit === undefined || material.einheit === null) {
      errors.push('Bitte Einheit eingeben.');
    }
    return errors;
  }

  public checkValidAusgabe(ausgabe: IAusgabe): any[] {
    if (ausgabe === null) {
      return ['Bitte Ausgabe eingeben.'];
    }
    const errors = [];
    if (!ausgabe.preis) {
      errors.push('Bitte Preis eingeben.');
    }
    if (!ausgabe.zeit) {
      errors.push('Bitte Zeit eingeben.');
    }
    if (!ausgabe.notizen) {
      errors.push('Bitte Grund eingeben.');
    }
    return errors;
  }

  public async checkValidBezahlMgl(bezahlMGL: IBezahlmgl): Promise<any[]> {
    if (bezahlMGL === null) {
      return ['Bitte Bezahlmöglichkeit eingeben.'];
    }
    const errors = [];

    await axios.post(`${baseApiUrl}/bezahlmgl`, bezahlMGL).then(res => {
      if (res.data === 1) {
        errors.push('Es ist bereits eine Bezahlmöglichkeit mit diesem Namen vorhanden.');
      }
    });
    if (!bezahlMGL.name) {
      errors.push('Bitte Name eingeben.');
    }
    if (bezahlMGL.name && bezahlMGL.name.length >= 255) {
      errors.push('Name zu lang.');
    }
    return errors;
  }

  public checkValidStammdaten(firmaInfo: FirmaInfo): any[] {
    if (firmaInfo === null) {
      return ['Bitte Firmendaten eingeben.'];
    }
    const errors = this.checkValidAdress(firmaInfo.address);

    if (!firmaInfo.name) {
      errors.push('Bitte Firmenname eingeben.');
    }
    if (firmaInfo.name && firmaInfo.name.length >= 510) {
      errors.push('Firmenname zu lang.');
    }
    if (!firmaInfo.steuernummer) {
      errors.push('Bitte Steuernummer eingeben.');
    }
    if (firmaInfo.steuernummer && firmaInfo.steuernummer.length >= 255) {
      errors.push('Steuernummer zu lang.');
    }
    if (!firmaInfo.iban) {
      errors.push('Bitte IBAN eingeben.');
    }
    if (firmaInfo.iban && firmaInfo.iban.length >= 255) {
      errors.push('IBAN zu lang.');
    }
    if (!firmaInfo.bic) {
      errors.push('Bitte BIC eingeben.');
    }
    if (firmaInfo.bic && firmaInfo.bic.length >= 255) {
      errors.push('BIC zu lang.');
    }
    if (!firmaInfo.bank_name) {
      errors.push('Bitte Name der Bank eingeben.');
    }
    if (firmaInfo.bank_name && firmaInfo.bank_name.length >= 255) {
      errors.push('Name der Bank zu lang.');
    }
    if (!firmaInfo.paypal) {
      errors.push('Bitte Paypaladresse eingeben.');
    }
    if (firmaInfo.paypal && firmaInfo.paypal.length >= 255) {
      errors.push('Paypaladresse zu lang.');
    }
    if (!firmaInfo.telefonnummer) {
      errors.push('Bitte Telefonnummer eingeben.');
    }
    if (firmaInfo.telefonnummer && firmaInfo.telefonnummer.length >= 255) {
      errors.push('Telefonnummer zu lang.');
    }
    if (!firmaInfo.zahlungsBedingung) {
      errors.push('Bitte Zahlungsbedingunen eingeben.');
    }
    if (firmaInfo.zahlungsBedingung && firmaInfo.zahlungsBedingung.length >= 1023) {
      errors.push('Zahlungsbedingunen zu lang.');
    }
    return errors;
  }

  public async checkValidNewGrundleistung(grundleistung: IGrundleistung): Promise<any[]> {
    if (grundleistung === null) {
      return ['Bitte Grundleistung eingeben.'];
    }
    const errors = [];

    await axios.post(`${baseApiUrl}/grundleistung`, grundleistung).then(res => {
      if (res.data === 1) {
        errors.push('Es ist bereits eine Grundleistung mit diesem Namen vorhanden.');
      }
    });
    return errors;
  }

  public async checkValidGrundleistung(grundleistung: IGrundleistung): Promise<any[]> {
    if (grundleistung === null) {
      return ['Bitte Grundleistung eingeben.'];
    }
    const errors = [];

    if (!grundleistung.name) {
      errors.push('Bitte Name eingeben.');
    }
    if (grundleistung.name && grundleistung.name.length >= 255) {
      errors.push('Name zu lang');
    }
    if (!grundleistung.preis) {
      errors.push('Bitte Preis eingeben.');
    }
    if (!grundleistung.rechnungtext) {
      errors.push('Bitte Text auf Rechnung eingeben.');
    }
    if (grundleistung.rechnungtext && grundleistung.rechnungtext.length >= 255) {
      errors.push('Text auf Rechnung zu lang');
    }
    return errors;
  }

  public checkValidAdress(adress: IAddress): any[] {
    if (adress === null) {
      return ['Bitte Adresse eingeben.'];
    }
    const errors = [];

    if (!adress.hausnummer) {
      errors.push('Bitte Hausnummer eingeben.');
    }
    if (adress.hausnummer && adress.hausnummer.length >= 255) {
      errors.push('Hausnummer zu lang.');
    }
    if (!adress.strasse) {
      errors.push('Bitte Straße eingeben.');
    }
    if (adress.strasse && adress.strasse.length >= 255) {
      errors.push('Strasse zu lang.');
    }
    if (!adress.plz) {
      errors.push('Bitte Postleitzahl eingeben.');
    }
    if (adress.plz && adress.plz.length >= 255) {
      errors.push('Postleitzahl zu lang.');
    }
    if (!adress.ort) {
      errors.push('Bitte Ort eingeben.');
    }
    if (adress.ort && adress.ort.length >= 255) {
      errors.push('Ort zu lang.');
    }
    if (adress.adresszusatz && adress.adresszusatz.length >= 255) {
      errors.push('Adresszusatz zu lang.');
    }
    return errors;
  }

  public async checkValidStall(stall: IStall): Promise<any[]> {
    if (stall === null) {
      return ['Bitte Stall eingeben.'];
    }
    const errors = this.checkValidAdress(stall.address);

    await axios.post(`${baseApiUrl}/stall`, stall).then(res => {
      if (res.data === 1) {
        errors.push('Es ist bereits ein Stall mit diesem Namen vorhanden.');
      }
    });
    if (!stall.name) {
      errors.push('Bitte Namen eingeben.');
    }
    if (stall.name && stall.name.length >= 255) {
      errors.push('Name zu lang.');
    }
    return errors;
  }

  public async checkValidPferd(pferd: IPferd): Promise<any[]> {
    if (pferd === null) {
      return ['Bitte Pferd eingeben.'];
    }
    const errors = [];

    await axios.post(`${baseApiUrl}/pferd`, pferd).then(res => {
      if (res.data === 1) {
        errors.push('Es ist bereits ein Pferd mit diesem Namen in diesem Stall von diesem Kunden vorhanden.');
      }
    });
    if (!pferd.name) {
      errors.push('Bitte Namen eingeben.');
    }
    if (pferd.name && pferd.name.length >= 255) {
      errors.push('Name zu lang.');
    }
    if (pferd.notizen && pferd.notizen.length >= 255) {
      errors.push('Notizen zu lang.');
    }
    if (!pferd.stall) {
      errors.push('Bitte Stall eingeben.');
    }
    if (!pferd.geburtsjahr) {
      errors.push('Bitte Geburtsjahr eingeben.');
    }
    if (pferd.geburtsjahr && pferd.geburtsjahr >= Number.MAX_SAFE_INTEGER) {
      errors.push('Geburtsjahr zu groß.');
    }
    if (!pferd.besitzer) {
      errors.push('Bitte Besitzer eingeben.');
    }
    return errors;
  }

  public checkValidLeistung(leistung: ILeistung): any[] {
    if (leistung === null) {
      return ['Bitte Leistung eingeben.'];
    }
    const errors = [];
    //console.log(leistung);
    if (leistung.notizen && leistung.notizen.length >= 255) {
      errors.push('Notizen zu lang');
    }
    if (leistung.zusatzleistungens !== undefined && leistung.zusatzleistungens !== null && leistung.zusatzleistungens.length !== 0) {
      leistung.zusatzleistungens.forEach(item => {
        if (item.anzahl === undefined || item.anzahl === null || item.anzahl.toString() === '') {
          errors.push('Zusatzleistungen müssen eine Anzahl haben');
        }
      });
    }
    return errors;
  }

  public checkValidTermin(termin: ITermin): any[] {
    if (termin === null) {
      return ['Bitte Termin eingeben.'];
    }
    const errors = this.checkValidLeistung(termin.leistung);
    if (termin.pferd && termin.zeit && termin.endzeit) {
      return errors;
    }

    if (!termin.pferd) {
      errors.push('Bitte Pferd und Stall eingeben.');
    }
    if (!termin.zeit) {
      errors.push('Bitte Zeit eingeben.');
    }
    if (!termin.endzeit) {
      errors.push('Bitte Dauer eingeben.');
    }
    return errors;
  }

  public checkValidTerminComplete(termin: ITermin): any[] {
    if (termin === null) {
      return ['Bitte Termin eingeben.'];
    }
    const errors = this.checkValidTermin(termin);
    if (termin.leistung && termin.leistung.grundleistung && termin.zahlungsart) {
      return errors;
    }

    if (!termin.leistung || !termin.leistung.grundleistung) {
      errors.push('Bitte Grundleistung eingeben.');
    }
    if (!termin.zahlungsart) {
      errors.push('Bitte Zahlungsart eingeben.');
    }
    return errors;
  }

  public async checkValidKunde(kunde: IKunde): Promise<any[]> {
    if (kunde === null) {
      return ['Bitte Kunde eingeben.'];
    }
    const errors = this.checkValidAdress(kunde.address);

    await axios.post(`${baseApiUrl}/kunde`, kunde).then(res => {
      if (res.data === 1) {
        errors.push('Es ist bereits ein Kunde mit diesem Namen und dieser Telefonnummer vorhanden.');
      }
    });
    if (!kunde.name) {
      errors.push('Bitte Namen eingeben.');
    }
    if (kunde.name && kunde.name.length >= 255) {
      errors.push('Name zu lang');
    }
    if (!kunde.vorname) {
      errors.push('Bitte Vornamen eingeben.');
    }
    if (kunde.vorname && kunde.vorname.length >= 255) {
      errors.push('Vorname zu lang');
    }
    if (!kunde.telefonnummer) {
      errors.push('Bitte Telefonnummer eingeben.');
    }
    if (kunde.telefonnummer && kunde.telefonnummer.length >= 255) {
      errors.push('Telefonnummer zu lang');
    }
    if (kunde.email && kunde.email.length >= 255) {
      errors.push('Email Adresse zu lang');
    }
    if (kunde.notizen && kunde.notizen.length >= 255) {
      errors.push('Notizen zu lang');
    }
    return errors;
  }

  public async checkValidZusatzleistung(zusatzleistung: IZusatzleistung): Promise<any[]> {
    const errors = [];
    if (zusatzleistung === null) {
      errors.push('Bitte Zusatzleistung eingeben.');
      return errors;
    }

    await axios.post(`${baseApiUrl}/zusatzleistung`, zusatzleistung).then(res => {
      if (res.data === 1) {
        errors.push('Es ist bereits eine Zusatzleistung mit diesem Namen vorhanden.');
      }
    });
    if (!zusatzleistung.name) {
      errors.push('Bitte Namen eingeben.');
    }
    if (zusatzleistung.name && zusatzleistung.name.length >= 255) {
      errors.push('Name zu lang');
    }
    if (!zusatzleistung.preis) {
      errors.push('Bitte Preis eingeben.');
    }
    if (!zusatzleistung.rechnungtext) {
      errors.push('Bitte Text auf Rechnung eingeben.');
    }
    if (zusatzleistung.rechnungtext && zusatzleistung.rechnungtext.length >= 255) {
      errors.push('Text auf Rechnung zu lang');
    }
    if (!zusatzleistung.mwst) {
      errors.push('Bitte Mehrwertsteuer eingeben.');
    }
    return errors;
  }
}
